import {Component, HostListener, Input, OnDestroy, OnInit} from '@angular/core';
import {PopUpService} from '../pop-up.service';
import {Subscription} from 'rxjs';
import {Router} from '@angular/router';
import {GlobalService} from '../../../servicos/global.service';
import {AutoUnsubscribe} from 'app/compartilhado/decorators/unsubscribe.decorator';

declare const $: any; // jquery

@Component({
  selector: 'app-pop-up-template', // colocar no HTML das telas que forem utilizar este componente
  templateUrl: './pop-up-template.component.html',
  styleUrls: ['../pop-up.scss']
})
@AutoUnsubscribe
export class PopUpTemplateComponent implements OnInit, OnDestroy {

  temaDark = this.globalService.tema;
  temaLight = !this.temaDark;
  subsRouter: Subscription; // subscription de mudança de rota
  isMobile: boolean;
  @Input() esconderTemplateAuto = true; // variavel para esconder o popup template quando a tela estiver grande (padrão é [true])
  @Input() titulo = '';

  /*  Constrói o PopUp, instaciando todos os serviços a serem utilizados pela mesma
 Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(private popUpService: PopUpService,
              private router: Router,
              private globalService: GlobalService) {
  }

  ngOnInit() {
    this.globalService.temaSub.subscribe((tema) => {
      if (tema) {
        this.temaDark = true;
        this.temaLight = false;
      } else {
        this.temaDark = false;
        this.temaLight = true;
      }
    });

    this.subsRouter = this.router.events.subscribe(() => { // escuta mudanças nas rotas
      $('#myModalTemplate').modal('hide'); // esconde o template caso haja mudança na rota
    });

    this.popUpService.templateSub.subscribe((mostrar) => { // escuta o subject templateSub
      if (mostrar) {
        $('#myModalTemplate').modal('show'); // mostra o pop-up
        this.popUpService.templateIsShowing = true;
        this.popUpService.templateHasToComeBack = false;
      } else {
        $('#myModalTemplate').modal('hide'); // esconde o pop-up
      }
    });

    $('#myModalTemplate').on('hidden.bs.modal', () => {
      // Evento disparado ao fechar o Modal de Template
      if (!this.popUpService.templateHasToComeBack) {
        this.popUpService.templateIsShowing = false;
        this.popUpService.templateHasToComeBack = false;
      }
      // Informa aos listeners que o pop-up fechou, permitindo a execução de funções que dependem desse evento.
      this.popUpService.popFechouSub.next();
    });
  }

  ngOnDestroy() {
  }

  @HostListener('window:resize') // escuta mudanças no tamanho da tela
  onResize() {
    this.isMobile = this.globalService.isMobileExtra(); // pega o tamanho da tela
    if (this.esconderTemplateAuto && !this.isMobile) { // caso esconderTemplateAuto seja [true] e tela for [mobile]
      $('#myModalTemplate').modal('hide'); // esconde o pop-up template
    }
  }
}